module.exports = __webpack_public_path__ + "media/images/preview_diary_1_thumb-c88d50010cb847caa01e980f6cc21da4.webp";